var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 59C45.7924 59 59 45.7924 59 29.5C59 13.2076 45.7924 0 29.5 0C13.2076 0 0 13.2076 0 29.5C0 45.7924 13.2076 59 29.5 59Z",
    fill: "#F2C94C",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2931 21.8422C38.8385 21.2321 37.3828 21 35.9278 21C31.309 20.9996 26.6906 23.3377 22.0718 23.3377C20.9134 23.3377 19.7558 23.1907 18.5975 22.8232C18.4674 22.782 18.3369 22.7625 18.2094 22.7625C17.564 22.7625 17 23.262 17 23.9553V35.8524C17 36.326 17.2711 36.7749 17.7065 36.9571C19.1611 37.5676 20.6168 37.7997 22.0718 37.7997C26.6906 37.7997 31.3094 35.4616 35.9282 35.4616C37.0866 35.4616 38.2442 35.6086 39.4025 35.9761C39.5326 36.0174 39.6631 36.0369 39.7906 36.0369C40.436 36.0369 41 35.5374 41 34.844V22.9473C40.9996 22.4734 40.7285 22.0249 40.2931 21.8422ZM28.9998 32.9998C27.3427 32.9998 25.9999 31.3877 25.9999 29.3999C25.9999 27.4117 27.3431 25.7999 28.9998 25.7999C30.6565 25.7999 31.9998 27.4117 31.9998 29.3999C31.9998 31.3885 30.6562 32.9998 28.9998 32.9998Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosts);
export default __webpack_public_path__ + "static/media/costs.0e3bc2777e89428c90d6f7cbce143930.svg";
export { ForwardRef as ReactComponent };